/**
 * Determines if the document is in RTL mode.
 * @returns {boolean} True if the document direction is RTL, otherwise false.
 */
export function getIsRtl(): boolean {
    const htmlElement = document.documentElement;
    const dir = htmlElement.getAttribute('dir');
    return dir === 'rtl';
}
